import React from 'react';
import { Device } from '../types';
import BuoyDetails from './device-types/BuoyDetails';
import NetatmoWeatherDetails from './device-types/NetatmoWeatherDetails';
import NetatmoIndoorDetails from './device-types/NetatmoIndoorDetails';
import NetatmoOutdoorDetails from './device-types/NetatmoOutdoorDetails';
import NetatmoRainDetails from './device-types/NetatmoRainDetails';
import NetatmoWindDetails from './device-types/NetatmoWindDetails';

interface DeviceTypeDetailsRendererProps {
  device: Device;
  deviceId: string;
}

const DeviceTypeDetailsRenderer: React.FC<DeviceTypeDetailsRendererProps> = ({ device, deviceId }) => {
  const deviceType = device.deviceType || 'buoy';

  console.log('DeviceTypeDetailsRenderer - Device ID:', deviceId);
  console.log('DeviceTypeDetailsRenderer - Device Type:', deviceType);
  console.log('DeviceTypeDetailsRenderer - Full Device:', device);

  switch (deviceType) {
    case 'buoy':
      return <BuoyDetails device={device} deviceId={deviceId} />;
    case 'netatmo_weather':
      return <NetatmoWeatherDetails device={device} deviceId={deviceId} />;
    case 'netatmo_indoor':
      return <NetatmoIndoorDetails device={device} deviceId={deviceId} />;
    case 'netatmo_outdoor':
      return <NetatmoOutdoorDetails device={device} deviceId={deviceId} />;
    case 'netatmo_rain':
      return <NetatmoRainDetails device={device} deviceId={deviceId} />;
    case 'netatmo_wind':
      return <NetatmoWindDetails device={device} deviceId={deviceId} />;
    default:
      return <BuoyDetails device={device} deviceId={deviceId} />;
  }
};

export default DeviceTypeDetailsRenderer;
